import {AccountProperties} from './Customer'

export enum ReadyKitState {
    NotChanged,
    Deleted,
    Created,
    Updated
}

export interface ReadyKitWithState extends ReadyKit {
    state: ReadyKitState
}

export enum ReadyKitPlatform {
    ReadyKit = 'readykit',
    KOPv1 = 'kopv1',
    KOPv2 = 'kopv2'
}

export const readyKitPlatformSuggestions = Object.entries(ReadyKitPlatform).map(([key, value]: [string, string]) => ({
    label: key,
    value
}))

export enum DatahubVersion {
    Default = 'default',
    V1 = 'v1',
    V3 = 'v3'
}

export const READYKIT_K_NUMBER_MAX_LENGTH = 8

export const rkTypeMapping: Record<string, string> = {
    'Physical ReadyKit': 'Physical',
    'Virtual ReadyKit Krones': 'Virtual Krones',
    'Virtual ReadyKit Customer': 'Virtual Customer'
}

export const rkPhaseMapping: Record<string, string> = {
    'Inhouse phase ReadyKit': 'Inhouse',
    'Onsite phase ReadyKit': 'Onsite'
}

export const datahubVersionSuggestions = Object.entries(DatahubVersion).map(([key, value]: [string, string]) => ({
    label: key,
    value
}))

export interface ReadyKit {
    accountProperties?: AccountProperties
    orderNumbersKrones?: string[]
    projectNosBasicConnectivity?: string[]
    links?: string[]
    location: {
        city?: string
        country?: string
        latitude?: string
        longitude?: string
        stateName?: string
        street?: string
        timezone?: string
        zipCode?: string
    }
    version: number
    name: string
    uuid: string
    customer: string
    rkType: string
    phase: string
    targetPlatform: ReadyKitPlatform
    currentPlatform?: ReadyKitPlatform
    dataHub: DatahubVersion
    kNumber?: string
    hasNetworkDrift?: boolean
    driftTime?: string
    networkLastSynced?: string
}

export interface ReadyKitDeviceProperty {
    name: string
    value: string
    description: string
}

export interface ReadyKitTypeAndPhaseListResponse {
    types: ReadyKitDeviceProperty[]
    phases: ReadyKitDeviceProperty[]
}

export const DEFAULT_RK_PHASE_VALUE = 'onsite-rk'
export const DEFAULT_RK_TYPE_VALUE = 'physical-rk'
